<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-chip-group column>
            <v-chip small v-if="creditNotesProposalsConfig.createdStart && creditNotesProposalsConfig.createdEnd"><b class="mr-1">Created:</b>{{`${creditNotesProposalsConfig.createdStart.replace(' 00:00','')} to ${creditNotesProposalsConfig.createdEnd.replace(' 23:59','')}`}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.accountId"><b class="mr-1">Account ID:</b>{{creditNotesProposalsConfig.accountId}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.billCycle.length"><b class="mr-1">Bill Cycle:</b>{{creditNotesProposalsConfig.billCycle.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.productKind.length"><b class="mr-1">Product Kind:</b>{{creditNotesProposalsConfig.productKind.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.amountFrom || creditNotesProposalsConfig.amountTo"><b class="mr-1">Amount:</b>{{`${creditNotesProposalsConfig.amountFrom || '-' } to ${creditNotesProposalsConfig.amountTo || '-'}`}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.shortReason.length"><b class="mr-1">Short Reason:</b>{{creditNotesProposalsConfig.shortReason.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.departments.length"><b class="mr-1">Department:</b>{{creditNotesProposalsConfig.departments.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.agents.length"><b class="mr-1">Agent:</b>{{creditNotesProposalsConfig.agents.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.approvalStatus.length"><b class="mr-1">Approval Status:</b>{{creditNotesProposalsConfig.approvalStatus.join(", ")}}</v-chip> 
            <v-chip small v-if="creditNotesProposalsConfig.approvers.length"><b class="mr-1">Approver:</b>{{creditNotesProposalsConfig.approvers.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.approvalDateStart && creditNotesProposalsConfig.approvalDateEnd"><b class="mr-1">Approval Date:</b>{{`${creditNotesProposalsConfig.approvalDateStart.replace(' 00:00','')} to ${creditNotesProposalsConfig.approvalDateEnd.replace(' 23:59','')}`}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.preApprovalStatus.length"><b class="mr-1">Pre-approval Status:</b>{{creditNotesProposalsConfig.preApprovalStatus.join(", ")}}</v-chip> 
            <v-chip small v-if="creditNotesProposalsConfig.preApprovers.length"><b class="mr-1">Pre-approver:</b>{{creditNotesProposalsConfig.preApprovers.join(", ")}}</v-chip>
            <v-chip small v-if="creditNotesProposalsConfig.preApprovalDateStart && creditNotesProposalsConfig.preApprovalDateEnd"><b class="mr-1">Pre-approval Date:</b>{{`${creditNotesProposalsConfig.preApprovalDateStart.replace(' 00:00','')} to ${creditNotesProposalsConfig.preApprovalDateEnd.replace(' 23:59','')}`}}</v-chip>
          </v-chip-group>

          <v-btn small class="mt-2" color="secondary" :loading="exportCredNoteProposalsLoading" :disabled="creditNotesProposals.length === 0" @click="exportCreditNoteProposals">
            <v-icon small class="mr-2">{{ mdiDownload }}</v-icon>
            Export
          </v-btn>
        </div>

        <v-data-table :loading="creditNotesProposalsLoading" :headers="headers" :items="creditNotesProposals" class="body--text" :server-items-length="creditNotesProposalsConfig.paginationCount" :page.sync="creditNotesProposalsConfig.paginationPage" :options.sync="options" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}" @click:row="openDialog">
          <template v-slot:header.short_reason="{ header }">
            <span class="pr-1">{{ header.text }}</span>
            <BaseInfoTooltip top>The reason for the credit</BaseInfoTooltip>
          </template>

          <template v-slot:item.creation_timestamp="{ item }">{{ item.creation_timestamp | formatDate | textPlaceholder }}</template>
          <template v-slot:item.account_id="{ item }">{{ item.account_id | textPlaceholder }}</template>
          <template v-slot:item.account.bill_cycle="{ item }">{{ item.account.bill_cycle | textPlaceholder }}</template>
          <template v-slot:item.product_type="{ item }">{{ item.product_type | formatStatus | textPlaceholder }}</template>
          <template v-slot:item.amount="{ item }">{{ item.amount | formatAmount | textPlaceholder }}</template>
          <template v-slot:item.short_reason="{ item }">{{ item.short_reason | textPlaceholder }}</template>
          <template v-slot:item.department="{ item }">{{ item.department | textPlaceholder }}</template>
          <template v-slot:item.agent_sid="{ item }">{{ item.agent_sid | textPlaceholder }}</template>
          <template v-slot:item.pre_approval_status="{ item }">{{ item.pre_approval_status | textPlaceholder }}</template>
          <template v-slot:item.approval_status="{ item }">{{ item.approval_status | textPlaceholder }}</template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon x-small color="primary" @click.stop="gotToLedger(item.account_id)"><v-icon>{{ledgerIcon}}</v-icon>  </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <CreditNotesActions :fetchCreditNotes="true" :openActions="openActions" @closeDialog="closeDialog" />
  </div>
</template>

<script>
  import { mdiBookOpenBlankVariant, mdiDownload } from '@mdi/js';
  import { mapState, mapActions } from "vuex";
  import moment from "moment";
  import CreditNotesActions from "@/components/CreditNotes/CreditNotesActions";

  
  const LEDGER_LINK = process.env.VUE_APP_LEDGER_LINK || `https://ledger-test-bonline.appspot.com/`;

  export default {
    components: {
      CreditNotesActions
    },

    data() {
      return {
        mdiDownload,
        ledgerIcon: mdiBookOpenBlankVariant,
        options: {
          sortBy: ['creation_timestamp'],
          sortDesc: true,
          itemsPerPage: 50,
        },
        itemsPerPageOptions: [5,10,15,25,50],
        headers: [
          { text: 'Created Date', value: 'creation_timestamp', sortable: false },
          { text: 'Account ID', value: 'account_id', sortable: false },
          { text: 'Bill Cycle', value: 'account.bill_cycle', sortable: false },
          { text: 'Product Type', value: 'product_type', sortable: false },
          { text: 'Amount', value: 'amount', sortable: false },
          { text: 'Short Reason', value: 'short_reason', sortable: false },
          { text: 'Department', value: 'department', sortable: false },
          { text: 'Agent', value: 'agent_sid', sortable: false },
          { text: 'Pre-approval Status', value: 'pre_approval_status', sortable: false },
          { text: 'Approval Status', value: 'approval_status', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        openActions: false
      }
    },

    filters: {
      textPlaceholder(val) {
        if(val === null || val === "" || val === undefined) return "-";
        return val;
      },
      formatDate(val) {
        if(!val) return "-";
        const date = new Date(val);
        return moment(date).format('YYYY/MM/DD');
      },
      formatStatus(val) {
        const map = {"voip": "VoIP", "web": "Website", "telco": "Telco"};
        if(map[val.toLowerCase()]) return map[val.toLowerCase()]
        return val;
      },
      formatAmount(val) {
        let ret = val.toFixed(2);
        return (ret>=0)?`£${ret}`:`-£${ret.replace('-','')}`;
      },
    },

    computed: {
      ...mapState("creditnotes", ["creditNotesProposals", "creditNotesProposalsLoading", "creditNotesProposalsError", "creditNotesProposalsConfig", "exportCredNoteProposalsLoading"]),
    },

    methods: {
      ...mapActions("creditnotes", ["fetchCreditNoteProposals", "updateCreditNoteProposalsPagination", "setCreditNotesProposalsActionAccount", "exportCreditNoteProposals"]),

      gotToLedger(id) {
        window.open(`${LEDGER_LINK}transactions/${id}`);
      },

      isEmpty(val) {
        return val === null || val === "" || val === undefined;
      },

      openDialog(e) {
        this.setCreditNotesProposalsActionAccount(e);
        this.openActions = true;
      },

      closeDialog(e) {
        this.openActions = e;
      }
    },

    watch: {
      options: {
        immediate: false,
        handler () {
          this.updateCreditNoteProposalsPagination(this.options);
        },
        deep: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-data-table ::v-deep tbody tr {
    cursor: pointer !important;
  }
</style>
